import { preservedImages } from '../data/preservedImages';

export { preservedImages };

const useOriginalStorage = import.meta.env.VITE_IMAGE_SOURCE === 'original-storage';
const originalUrls = Object.fromEntries(Object.entries(preservedImages.urls).map(([remote, local]) => [local, remote]));

// Local builds use byte-identical backups; hosted builds use the same original storage.
// URLs for future uploads pass through unchanged in both modes.
export function preservedImageUrl(url: string): string {
  if (useOriginalStorage) return originalUrls[url] ?? url;
  return preservedImages.urls[url] ?? url;
}

export function cachedImageMap(key: string, fallback: Record<string, string>): Record<string, string> {
  const images = Object.fromEntries(Object.entries(fallback).map(([id, url]) => [id, preservedImageUrl(url)]));
  try {
    const cache: unknown = JSON.parse(localStorage.getItem(key) || '{}');
    if (cache && typeof cache === 'object' && !Array.isArray(cache)) {
      for (const [id, url] of Object.entries(cache)) {
        if (typeof url === 'string' && url) images[id] = preservedImageUrl(url);
      }
    }
  } catch { /* The original image snapshot remains available without a cache. */ }
  return images;
}
